import Modal from "@/components/core/Modal/Modal"
import React, { useState } from "react"
import htmlParser from "html-react-parser"
import {
  addAnalyticsForViewNowClick,
  addAnalyticsForCloseClick,
} from "@/components/ProductDetail/v3/ProductDetailView/analytics/analytics"

const Product3Dmodel = ({
  pdpJson = {},
  sku = "",
  nvznList = [],
  vntanaList = [],
  productInfo = {},
}) => {
  const [showModal, setShowModal] = useState(false)
  const openModal = () => {
    setShowModal(true)
    addAnalyticsForViewNowClick(productInfo)
  }
  const closeModal = () => {
    setShowModal(false)
    addAnalyticsForCloseClick(productInfo)
  }
  const {
    iframeTitle = "",
    iframeDescription = "",
    iframeCTA = "",
    fileReferenceIframe = "",
    iframePlayers = [],
  } = pdpJson
  const areBothPlayersAvaialbe = nvznList.length && vntanaList.length
  const availablePlayerIdParam = nvznList.length ? "NVZN" : "VNTANA"
  const filterWith = areBothPlayersAvaialbe ? "priorityIframe" : "iframeID"

  const iframeToConsider =
    iframePlayers.find(item =>
      areBothPlayersAvaialbe
        ? item[filterWith]
        : item[filterWith].includes(availablePlayerIdParam)
    ) ?? {}
  const { iframeURL = "", iframeID = "" } = iframeToConsider
  const playerIds = (iframeID === "NVZN" ? nvznList : vntanaList) ?? []

  const getPlayerId = () => {
    const playerIdBasedSku = playerIds.filter(
      item => item.split("|")[0] === sku
    )
    return playerIdBasedSku.length ? playerIdBasedSku[0].split("|")[1] : ""
  }
  const playerId = getPlayerId()

  const pdp3DIframe = iframeURL.replace("{{ID}}", playerId)
  if (!playerId) return null
  return (
    <div className="product-detail-page__3d-modal">
      <div className="product-detail-page__3d-modal--title">{iframeTitle}</div>
      <div className="product-detail-page__3d-modal--decs">
        {iframeDescription}
      </div>
      <div className="product-detail-page__3d-modal--modal-popup">
        <div className="product-detail-page__3d-modal--icon">
          {fileReferenceIframe ? (
            <img src={fileReferenceIframe} alt={iframeCTA} />
          ) : null}
          <div className="product-detail-page__3d-modal--button">
            <span
              tabIndex="0"
              role="button"
              aria-label={"view"}
              onClick={openModal}
            >
              {iframeCTA}
            </span>
          </div>
        </div>
        <Modal
          showModal={showModal}
          onModalClose={closeModal}
          isWhiteCloseIcon={true}
        >
          {pdp3DIframe ? htmlParser(pdp3DIframe) : null}
        </Modal>
      </div>
    </div>
  )
}
export default Product3Dmodel
